import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

function InfoCard({ title, number }) {
  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h6" component="div">
            {title}
          </Typography>
          <Typography variant="h3" component="div" color="primary">
            {number}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

export default InfoCard;
